import { Body, Heading } from '@assembly-js/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsDocsLink } from './SettingsDocsLink';

interface SettingsPageHeaderProps {
  title: string;
  description?: string;
  docsUrl?: string;
  /** Sits beside the title, e.g. the plan a locked page needs. */
  badge?: React.ReactNode;
}

export const SettingsPageHeader = ({
  title,
  description,
  docsUrl,
  badge,
}: SettingsPageHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header>
      <div className="flex items-center gap-2">
        {/* Heading's xl size ships a 12px line height, which crushes the title
            against the description. */}
        <Heading
          size="xl"
          tag="h1"
          className="mb-0! leading-[28px] tracking-[-0.01em] text-black-heading"
        >
          {title}
        </Heading>
        {badge}
      </div>
      {(description || docsUrl) && (
        <Body size="base" className="mt-1 leading-[22px] text-secondary">
          {description}
          {docsUrl && (
            <>
              {description && ' '}
              <SettingsDocsLink href={docsUrl}>
                {t(($) => $.page_settings.page_header.docs)}
              </SettingsDocsLink>
            </>
          )}
        </Body>
      )}
    </header>
  );
};
